module.exports = __webpack_public_path__ + "static/media/alert_widget_icon.fc5b8981.svg";